import React, {useState} from 'react'
import Multiple from 'Components/Multiple'

export default React.memo(props => {

  const [value, setValue] = useState(props.infoTiers === true && props.data !== undefined ? props.data.id : props.data)

    return (
      <Multiple inputStyle={{
                  padding: 0
                }}
                title={props.title} options={props.options} onChange={props.onChange}
                value={(props.infoTiers ? props.data && props.data.id : props.data) || []} inline={props.inline}
                disabled={props.disabled} libelleEmpty={props.libelleEmpty}/>
    )
})



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/DataComponent/Components/ComboMulti.js